import React, { useState, useEffect, useRef } from 'react';
import { Link,} from 'react-router-dom';
import { Link as LinkScroll } from 'react-scroll';
import Select from 'react-select';
//import { Redirect } from 'react-router-dom';

import uniqid from 'uniqid';

import Swal from 'sweetalert2'

import { WithContext as ReactTags } from 'react-tag-input';

import { getTokenInfo } from '../../../UseToken';
//import UseSidebar from '../../../UseSidebar';

import Loader from '../../Loader/Loader';

import {api_crud_base, api_crud_route, data_interface, endpoints } from './Config';
import AssecCKEditor from "../../ASSEC_CKEditor/ASSEC_CKEditor";

import SortableTree from 'react-sortable-tree';
import 'react-sortable-tree/style.css'; // This only needs to be imported once in your app

import DraggableDivImage from "../../DraggableDiv/DraggableDivImage"
//import { List, arrayMove } from "react-movable";;

import {
	reqGET,
	reqPOST,
	reqDELETE,
	reqPUT,
	reqFILE,
	content_language,
	replace_slug_string
} from '../../../Utils';
import Hosts from '../../../Hosts';

import Main from '../../Main/Init'

import { language } from './Language';

export default function Regist(props) {

	const [, set_dados] = useState(null);
	const dados = useRef(null);

	const [/*date_creation*/, set_date_creation] = useState('') 
	const [/*date_modification*/, set_date_modification] = useState('') 
	const [date_publication, set_date_publication] = useState('') 
	const [date_begin, set_date_begin] = useState('') 
	const [date_end, set_date_end] = useState('') 
	const [date_registration_begin, set_date_registration_begin] = useState('') 
	const [date_registration_deadline, set_date_registration_deadline] = useState('') 
	const [date_extension, set_date_extension] = useState('') 

	const [lang, set_lang] = useState('pt');
	const [uid, ] = useState(uniqid());

	const [/*isSlug*/, setSlug] = useState(false);

	/* FORMATION MODULES */
	const [module_name, set_module_name] = useState('')
	const [module_sessions_number, set_module_sessions_number] = useState('')
	const [module_evaluations_number, set_module_evaluations_number] = useState('')
	const [module_evaluation, set_module_evaluation] = useState('')
	const [module_duration, set_module_duration] = useState('')
	const [module_description, set_module_description] = useState('')
	const [module_objectives, set_module_objectives] = useState('')

	/* END FORMATION MODULES */

	//const [disabled, set_disabled] = useState(false)

	const [isloading, setLoading] = useState(true);
	//const [save_label, set_save_label] = useState('Salvar');
	//const [isRedirect, setRedirect] = useState(false);

	const [show_delete_button, set_show_delete_button] = useState(false);

	const [is_edit, set_is_edit] = useState(false)

	//const add_trainers_permission = ('Administrador' === getTokenInfo().profile || 'Gestor de formações' === getTokenInfo().profile || 'Coordenador de formações' === getTokenInfo().profile);

	const [/*editorLoaded*/, setEditorLoaded] = useState(false);

	//const [uploadedFiles, setUploadedFiles] = useState([]);
	
	const [/*selectedFile*/, setSelectedFile] = useState(null);
	//const [selectedFiles, setSelectedFiles] = useState([]);

	const [treeData, setTreeData] = useState([]) 
	const [tags, setTags] = useState([]);

	const [suggestions, set_suggestions] = useState([])
	const [keycodes, /*set_keycodes*/] = useState({comma: 188, enter: 13 })
    const [delimiters, /*set_delimiters*/] = useState([keycodes.comma, keycodes.enter])


	const [refresh, setRefresh] = useState(0);

	const [/*dragId*/, setDragId] = useState();

	const [files_image, set_files_image] = useState([]);
	const [image_base64, set_image_base64] = useState([]);
	
	const [files_doc, set_files_doc] = useState([]);
	const [files_doc_name, set_files_doc_name] = useState([]);

	const handleDrag = (ev) => {
		console.log('drag ev', ev)

	  	setDragId(ev.currentTarget.id);
	};

	const handleDrop = (ev) => {

		console.log('drop')
		return

		/*const { dataset } = ev.target;
		const { order } = dataset

		console.log('drop')

		let divs = dados.current.content[order].media.image

		console.log('ev', ev)
		console.log('divs', divs)

		const dragDiv = divs.find((div) => div.id === dragId);
		const dropDiv = divs.find((div) => div.id === ev.currentTarget.id);
	
		const dragDivOrder = dragDiv.order;
		const dropDivOrder = dropDiv.order;
	
		const newDivState = divs.map((div) => {
		  if (div.id === dragId) {
			div.order = dropDivOrder;
		  }
		  if (div.id === ev.currentTarget.id) {
			div.order = dragDivOrder;
		  }
		  return div;
		});
	
		console.log('divs', newDivState);*/
	};

	const handleEdit = (order) => {
		set_dados(dados.current.content[order].media)
	};

	const handleRemove = (order, langid, id, link) => {

		Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
		.then((result) => {
			if (result.isConfirmed) {

				if (langid === '1') {
					let aux = dados.current.content[order].media.image.filter(v => v.link !== link)
					set_dados(dados.current.content[order].media.image = aux)
				}
				else {

					console.log(langid)
					console.log(dados.current.content[order].language)
					console.log(dados.current.content[order].language[langid])

					let aux = dados.current.content[order].language[langid].media.image.filter(v => v.link !== link)
					set_dados(dados.current.content[order].language[langid].media.image = aux)
				}

			}
		})

	};

	const handleChangeContentMediaImage = (e) => {
		const { value, name, dataset } = e.target;
		const { order, id } = dataset

		dados.current.content[order].media.image.forEach(el => {
			if(el.id === id)
				el[name] = value
		})
		set_dados(dados.current.content[order].media.image)

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}
	
	const fetch_id_info = async (id_serch) => {
		return await reqGET(`${api_crud_route}/${getTokenInfo().companycode}/${id_serch}`)
			.then(res => {
				set_dados(dados.current = res.data[0]);
				if(res.data[0].info['media'] !== undefined)
					setSelectedFile(res.data[0].info.media)

				let aux = []
				res.data[0].content.forEach((el, k) => {
					if(el.media !== undefined) {
						aux[k] = []
						aux[k][1] = el.media
					}

					if(el['language'] !== undefined && el['language'].length > 0) {
						el['language'].forEach((el_2) => {
							if(el_2 !== undefined && el_2 !== null) {
								if(el_2['media'] !== undefined && el_2['media'] !== null)
									aux[k][el_2.id] = [{image: [], doc: []}]
		
								if(el_2.media !== undefined)
									aux[k][el_2.id] = el_2.media
							}
						})
					}
				})

				//setSelectedFiles(aux)

				let aux_doc = []
				let i = 0
				aux.forEach((el, k) => {
					el.forEach((el_2, k_2) => {
						el_2.doc.forEach((el_3) => {
							if(aux_doc[k] === undefined)
								aux_doc[k] = []
							if(aux_doc[k][k_2] === undefined)
								aux_doc[k][k_2] = []
								
							aux_doc[k][k_2].push({ id: ++i, id_doc: el_3.id, title: el_3.name, link: el_3.link, visible: el_3.visible})
						})
					})
				})
				setTreeData(aux_doc)
				//console.log(res.data[0])
			})
			.catch(error => console.log(error))
	}

	const fetch_formation_categories = async () => {
		return await reqGET(`${api_crud_base}/formation/category/${getTokenInfo().companycode}`)
			.then(res => {
				
				let suggestions_aux = []
				res.data.forEach((el) => {
					suggestions_aux.push({id: el.info.name, text: el.info.name})
				})
				set_suggestions(suggestions_aux)

			})
			.catch(error => console.log(error)/*TODO: GO TO FAIL FETCH*/)
	}

	const clean_data = async () => {		
		// DEEP COPY OF data_interface 
		set_dados(dados.current = JSON.parse(JSON.stringify(data_interface)))
		set_dados(dados.current.info.companycode = getTokenInfo().companycode)
	}



	useEffect(() => {
		//setEditorLoaded(true);
		get_trainers();
		clean_data();

		set_lang(localStorage.getItem('lang'))

		fetch_formation_categories()


		try {
			let test = props.location.state.operation;

			if (test === 'edit') {
				set_is_edit(true)
				set_show_delete_button(true)

				set_image_base64([])
				set_files_doc_name([])

				fetch_id_info(props.location.state.item['id'])
					.then(() => {

						if(dados.current.info.date.creation !== undefined && dados.current.info.date.creation !== '') {
							let date_creation = new Date(dados.current.info.date.creation); 
							set_date_creation(date_creation.getDate().toString().padStart(2, '0') + '/' + (date_creation.getMonth() + 1).toString().padStart(2, '0') + '/' + date_creation.getFullYear())
						}
						if(dados.current.info.date.publication !== undefined && dados.current.info.date.publication !== '') {
							let date_publication = new Date(dados.current.info.date.publication); 
							set_date_publication(date_publication.getDate().toString().padStart(2, '0') + '/' + (date_publication.getMonth() + 1).toString().padStart(2, '0') + '/' + date_publication.getFullYear())
						}
						if(dados.current.info.date.begin !== undefined && dados.current.info.date.begin !== '') {
							let date_begin = new Date(dados.current.info.date.begin); 
							set_date_begin(date_begin.getDate().toString().padStart(2, '0') + '/' + (date_begin.getMonth() + 1).toString().padStart(2, '0') + '/' + date_begin.getFullYear())
						}
						if(dados.current.info.date.end !== undefined && dados.current.info.date.end !== '') {
							let date_end = new Date(dados.current.info.date.end); 
							set_date_end(date_end.getDate().toString().padStart(2, '0') + '/' + (date_end.getMonth() + 1).toString().padStart(2, '0') + '/' + date_end.getFullYear())
						}
						if(dados.current.info.date.registration_begin !== undefined && dados.current.info.date.registration_begin !== '') {
							let date_registration_begin = new Date(dados.current.info.date.registration_begin); 
							set_date_registration_begin(date_registration_begin.getDate().toString().padStart(2, '0') + '/' + (date_registration_begin.getMonth() + 1).toString().padStart(2, '0') + '/' + date_registration_begin.getFullYear())
						}
						if(dados.current.info.date.registration_deadline !== undefined && dados.current.info.date.registration_deadline !== '') {
							let date_registration_deadline = new Date(dados.current.info.date.registration_deadline); 
							set_date_registration_deadline(date_registration_deadline.getDate().toString().padStart(2, '0') + '/' + (date_registration_deadline.getMonth() + 1).toString().padStart(2, '0') + '/' + date_registration_deadline.getFullYear())
						}
						if(dados.current.info.date.extension !== undefined && dados.current.info.date.extension !== '') {
							let date_extension = new Date(dados.current.info.date.extension); 
							set_date_extension(date_extension.getDate().toString().padStart(2, '0') + '/' + (date_extension.getMonth() + 1).toString().padStart(2, '0') + '/' + date_extension.getFullYear())
						}
						if(dados.current.info.date.modified !== undefined && dados.current.info.date.modified.length > 0) {
							let date_modification = new Date(dados.current.info.date.modified.pop());
							set_date_modification(date_modification.getDate().toString().padStart(2, '0') + '/' + (date_modification.getMonth() + 1).toString().padStart(2, '0') + '/' + date_modification.getFullYear())
						}

						if(dados.current.info['tags'] === undefined)
							dados.current.info['tags'] = []

						setLoading(false)
						setEditorLoaded(true);
					})
				return			
			}

			// VAI REGISTAR
			if (test === undefined) {
				setLoading(false);
				return
			}
		} catch {
			// VAI REGISTAR

			//setRedirect(false);
			setLoading(false)

			clean_data()
				.then(() => {
					setEditorLoaded(true);
				})	
		
			return
		}

		//props.history.push(endpoints.list)
		return () => {
			clean_data()
		}
	}, [props])

	const handleSubmit = async e => {
		e.preventDefault();

		var today_submit = new Date()

		if (is_edit === true) {
			//alert('Atualizar PUT')

			if(dados.current.info.uniqid !== undefined)
				delete dados.current.info.uniqid;
				
			Swal.fire({
				title: language[lang].edit_title,
				text: language[lang].edit_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].edit_confirm,
				cancelButtonText: language[lang].edit_cancel
			})
			.then((result) => {
				if (result.isConfirmed) {

					files_image.forEach(async (el_image) => {
						if(el_image !== null) {
							await uploadFilesImage(el_image.files, el_image.order, 'image', el_image.langid, el_image.lang)
						}
					})
					set_files_image([])

					files_doc.forEach(async (el_doc) => {
						if(el_doc !== null) {
							await uploadFilesDoc(el_doc.files, el_doc.order, 'doc', el_doc.langid, el_doc.lang)
						}
					})
					set_files_doc([])
					set_files_doc_name([])

					dados.current.info.date.modified.push(today_submit)
					reqPUT(api_crud_route, dados.current)
						.then(() => { 
							//props.history.push(endpoints.list) 
						})
						.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))
				}
			})
		} else {
			Swal.fire({
				title: language[lang].insert_title,
				text: language[lang].insert_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].insert_confirm,
				cancelButtonText: language[lang].insert_cancel
			})
			.then((result) => {
				if (result.isConfirmed) {
					dados.current.info['uniqid'] = uid
					dados.current.info.date.creation = today_submit
					reqPOST(api_crud_route, dados.current)
						.then(() => { 

							reqGET(`${api_crud_base}/formation/course/uniqid/${getTokenInfo().companycode}/${uid}`)
								.then(res => {
									console.log(res.data)
									dados.current.id = res.data[0].id

									files_image.forEach(async (el_image) => {
										if(el_image !== null) {
											await uploadFilesImage(el_image.files, el_image.order, 'image', el_image.langid, el_image.lang)
										}
									})
									set_files_image([])

									files_doc.forEach(async (el_doc) => {
										if(el_doc !== null) {
											await uploadFilesDoc(el_doc.files, el_doc.order, 'doc', el_doc.langid, el_doc.lang)
										}
									})
									set_files_doc([])
									set_files_doc_name([])

									set_is_edit(true)
									set_show_delete_button(true)
								})
								.catch(() => 404)

							//props.history.push(endpoints.list) 
						})
						.catch(() => Swal.fire(language[lang].insert_error, '', 'info'))
				}
			})
		}
	}

	function apagar() {
		Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
		.then((result) => {
			if (result.isConfirmed) {

				remove_content_from_menu(dados.current.id)

				reqDELETE(api_crud_route + '/', { id: dados.current.id })
					.then(() => {
						
						props.history.push(endpoints.list);

					})
					.catch(() => Swal.fire(language[lang].delete_error, '', 'info'))
			}
		})
	};

	const remove_content_from_menu = async (id) => {
		return await reqGET(`${api_crud_base}/web/structure/${getTokenInfo().companycode}`)
			.then(res => {

				res.data.forEach((value) => {
					if(value.content !== undefined && value.content['childs'].length > 0) {

						value.content.childs = value.content.childs.filter(v => v.id_content !== id)
						remove_menu_childs(value.content.childs, id)

						reqPUT(`${api_crud_base}/web/structure`, value)
							.then(() => {
								//console.log('sucesso')
							})
							.catch(error => console.log(error)/*TODO: GO TO FAIL FETCH*/)

					}
				})
				
			})
			.catch(error => console.log(error)/*TODO: GO TO FAIL FETCH*/)
	}

	/*const change_item_menu_childs = (menu, name, value, id) => {

		if(menu !== undefined && menu.length > 0) {
			menu.forEach((v) => {

				if(v.id_content === id) {
					v[name] = value
				}

				if(v.children !== undefined && v['children'].length > 0) {
					return change_item_menu_childs(v.children, name, value, id)
				}
				else {
					return menu
				} 
			})
		}
		else {
			return menu
		}
	}*/

	const remove_menu_childs = (menu, id) => {

		let menu2 = menu.filter(v => v.id_content !== id)
		if(menu2 !== undefined && menu2.length > 0) {
			menu2.forEach((value) => {
				if(value.children !== undefined && value['children'].length > 0) {
					let menu3 = value.children.filter(v => v.id_content !== id)
					if(menu3 !== undefined && menu3.length > 0) {
						return remove_menu_childs(menu3, id)
					}
					else {
						value.children = []
						return value.children
					}
				}
				else {
					return menu2
				} 
			})
		}
		else {
			return menu
		}


	}

	const handle_change_info = (e) => {
		const { name, value } = e.target;

		set_dados(dados.current.info[name] = value)
		
		//console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		//console.log('Dados Current:' + JSON.stringify(dados))
	}

	const handle_change_content_nolang = (e) => {
		const { name, value } = e.target;

		set_dados(dados.current.content[0][name] = value)
		
		console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		console.log('Dados Current:' + JSON.stringify(dados))
	}

	const handle_change_content_financing = (e) => {
		const { value } = e.target;

		set_dados(dados.current.content[0]['financing'] = value)
		setRefresh(refresh + 1)
		
		console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		console.log('Dados Current:' + JSON.stringify(dados))
	}


	const handle_change_content_language = (e) => {
		const { value } = e.target;

		set_dados(dados.current.content[0]['formation_lang'] = value)
		setRefresh(refresh + 1)
		
		console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		console.log('Dados Current:' + JSON.stringify(dados))
	}



	const handle_change_info_slug = async (e) => {
		const { name, value } = e.target;

		if(value !== '') {

			let v = replace_slug_string(value)
			get_slug(v, 0)
				.then((res) => {
					if(res) {
						get_slug(v, 1)
							.then((res_2) => {
								set_dados(dados.current.info[name] = res_2)
								e.target.value = res_2

								// setRefresh(refresh + 1)
								// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
								// console.log('Dados Current:' + JSON.stringify(dados))
							})
					}
					else {
						set_dados(dados.current.info[name] = v)

						// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
						// console.log('Dados Current:' + JSON.stringify(dados))
					}
				})
		}
		else {
			set_dados(dados.current.info[name] = '')

			// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
			// console.log('Dados Current:' + JSON.stringify(dados))
		}
	}

	const handle_change_content = (e) => {
		const { name, value, dataset } = e.target;
		const { order, lang, langid } = dataset

		if(langid === '1') {
			set_dados(dados.current.content[order][name] = value)

			if(name === 'title' && order === '0' && is_edit === false) {
				set_dados(dados.current.info.name = value)
				set_dados(dados.current.info.seo.title = value)
			}
		}
		else {
			if(dados.current.content[order]['language'] === undefined)
				dados.current.content[order]['language'] = []

			if(dados.current.content[order].language.length  === 0) {
				//dados.current.content[order].language[lang] = {id: langid, code: lang, title: '', abstract: '', text: ''}
				dados.current.content[order].language[langid] = {id: langid, code: lang, title: '', text: '', media: {image: [], doc: []}}
			}

			set_dados(dados.current.content[order]['language'][langid][name] = value)
		}
		
		console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		console.log('Dados Current:' + JSON.stringify(dados))
	}

	const handle_change_content_ckeditor = (value, order, langid, lang, name) => {
	
		console.log('handle_change_info_ckeditor');

		if(langid === '1') {
			set_dados(dados.current.content[order][name] = value)
		}
		else {
			if(dados.current.content[order]['language'] === undefined)
				dados.current.content[order]['language'] = []

			if(dados.current.content[order].language.length  === 0) {
				dados.current.content[order].language[langid] = {id: langid, code: lang, title: '', text: '', media: {image: [], doc: []}}
			}

			set_dados(dados.current.content[order]['language'][langid][name] = value)
		}

		console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		console.log('Dados Current:' + JSON.stringify(dados))
	}

	const get_value_content_lang = (order, langid, name) => {
		if(dados.current.content[order]['language'] !== undefined && dados.current.content[order]['language'] !== null) {
			if(dados.current.content[order]['language'][langid] !== undefined && dados.current.content[order]['language'][langid] !== null) {
				return dados.current.content[order]['language'][langid][name];
			}
			else {
				return '';
			}
		}
		else {
			return '';
		}
	}

	const handle_change_info_seo = (e) => {
		const { name, value } = e.target;

		if(!dados.current.info.seo)
			dados.current.info.seo = {}

		set_dados(dados.current.info.seo[name] = value)
		
		//console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		//console.log('Dados Current:' + JSON.stringify(dados))
	}

	const get_slug = async (slug, i) => {

		if(i === 0) {
			return await reqGET(`${api_crud_base}/web/content/slug/${getTokenInfo().companycode}/${slug}`)
				.then(res => {

					if(res.data.length > 0) {

						if(props.location.state.item['id'] === res.data[0].id) {
							setSlug(false)
							return false

						}else{
							setSlug(true)
							return true
						}
					}
					else {
						setSlug(false)
						return false
					}
				})
				.catch(error => console.log(error)/*TODO: GO TO FAIL FETCH*/)
		}
		else {
			return await reqGET(`${api_crud_base}/web/content/slug/${getTokenInfo().companycode}/${slug}-${i}`)
			.then(res => {
				if(res.data.length > 0) {
					//setSlug(true)
					return get_slug(slug, i + 1)
				}
				else {
					setSlug(false)
					return slug + '-' + i
				}
			})
			.catch(error => console.log(error)/*TODO: GO TO FAIL FETCH*/)
		}
	}

    /*const onChangeHandlerFile = (e) => {
        const { files } = e.target;
        let aux = []

		console.log('2')


        files.forEach((element) => {
            aux.push(element)
        })

        setUploadedFiles(aux)
    }*/

	const convertBase64 = async (file) => {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(file);
        
            fileReader.onload = () => {
                resolve(fileReader.result);
            };
        
            fileReader.onerror = (error) => {
                reject(error);
            };
        });
    };

	const onChangeHandlerFilesImage = async (e) => {
       	const { files, dataset } = e.target;
		const { order, langid, lang } = dataset

		let storedFiles = [];
		let filesArray = Array.prototype.slice.call(files);

		filesArray.forEach(async (v) => {
			if((v.type.includes('image/')) && (v.size < 10485760)){
				storedFiles.push(v);

				const base64 = await convertBase64(e.target.files[0]);
				let files_img_aux = image_base64
				
				if(files_img_aux[order] === undefined)
					files_img_aux[order] = []
				if(files_img_aux[order][langid] === undefined)
					files_img_aux[order][langid] = []
				
				files_img_aux[order][langid] = [{id: '1', langid: langid, name: v.name, link: base64}]
				set_image_base64(files_img_aux)

				if(langid === '1') {
					if(dados.current.content[order]['media'] === undefined)
						dados.current.content[order]['media'] = {image: [], doc: []}

					if(dados.current.content[order]['media']['image'] !== undefined)
						dados.current.content[order]['media']['image'] = []
				}
				else {
					if(dados.current.content[order]['language'][langid]['media'] === undefined)
						dados.current.content[order]['language'][langid]['media'] = {image: [], doc: []}

					if(dados.current.content[order]['language'][langid]['media'] === undefined)
						dados.current.content[order]['language'][langid]['media'] = {image: [], doc: []}

					if(dados.current.content[order]['language'][langid]['media']['image'] !== undefined)
						dados.current.content[order]['language'][langid]['media']['image'] = []
				}

				set_dados(dados.current,)
				setRefresh(refresh + 1)
			}
			else{
				alert( language[ lang ].upload_file_error + v.name);
			}
		});	

		let files_aux = files_image
		files_aux[langid] = {files: storedFiles, order: order, lang: lang, langid: langid}
		set_files_image(files_aux)
    }

	const uploadFilesImage = (files, order, type, langid, lang) => {

		let aux = []
        files.forEach(async (element) => {
			if(element.type.includes('image/')) {
				aux.push(element)

				await uploadFile(element, order, type, langid, lang)
				   .then(() => {
						//console.log('success')
				   })
			}
			else {
				Swal.fire('Formato do ficheiro incorrecto!', '', 'info')
			}
        })
    }

	const onChangeHandlerFilesPDF = (e) => {
        const { files, dataset } = e.target;
		const { order, langid, lang } = dataset

		let storedFiles = [];
		let filesArray = Array.prototype.slice.call(files);

		filesArray.forEach(async (v) => {
			if((v.type.includes('/pdf')) && (v.size < 10485760)){
				storedFiles.push(v);

				let aux2 = files_doc_name
				if(aux2[langid] === undefined)
					aux2[langid] = []
				aux2[langid].push({name: v.name, size: v.size})
				set_files_doc_name(aux2)

				let aux_doc = treeData
				if(treeData[order] === undefined)
					treeData[order] = []
				if(treeData[order][langid] === undefined)
					treeData[order][langid] = []
				let i = treeData[order][langid].length
				aux_doc[order][langid].push({ id: ++i, id_doc: '', title: v.name, link: v.link, visible: true})
				setTreeData(aux_doc)

				set_dados(dados.current,)
				setRefresh(refresh + 1)
			}
			else{
				alert( language[ lang ].upload_file_error + v.name);
			}
		});	

		let files_aux = files_doc
		files_aux[langid] = {files: storedFiles, order: order, lang: lang, langid: langid}
		set_files_doc(files_aux)
    }

	const uploadFilesDoc = (files, order, type, langid, lang) => {
        let aux = []
        files.forEach((element) => {
			if(element.type === "application/pdf") {
				aux.push(element)

				uploadFile(element, order, type, langid, lang)
				    .then(() => {
						//console.log('success')
				    })
			}
			else {
				Swal.fire('Formato do ficheiro incorrecto!', '', 'info')
			}
        })
    }

	const uploadFile = async (file, order, type, langid, lang) => {
        const formData = new FormData()
        formData.append('files', file)
        formData.append('id', dados.current.id)
		formData.append('file_name', file.name)
        formData.append('type', 'formation')
        formData.append('companycode', dados.current.info.companycode)
        formData.append('uniqid', dados.current.info.uniqid)
		formData.append('folder', Hosts.APP_REPO_FOLDER + 'upload/app/');

        return await reqFILE(`${api_crud_base}/multimedia/file`, formData)
            .then((res) => { 
                var today_file = new Date()

                let x = {
                    id: '',
                    info: {
                        companycode: getTokenInfo().companycode,
                        type: res.data.mimetype,
                        link: res.data.path + '/' + res.data.name,
                        size: res.data.size,
                        date: today_file
                    },
					content: {
						name: file.name,
                        description: '',
						lang: []
					}
                }

				console.log(langid)
				if(langid === '1'){
					if(type === 'image') {
						dados.current.content[order]['media'][type] = [{ 
							id: '',
							link: res.data.path + '/' + res.data.name,
							name: res.data.name,
							description: '',
							type: type,
							order: order,
							lang: []
						}]
					}
					if(type === 'doc') {
						dados.current.content[order]['media'][type].push({ 
							id: '',
							link: res.data.path + '/' + res.data.name,
							name: res.data.name,
							description: '',
							type: type,
							order: order,
							lang: []
						})
					}
				}
				else {
					if(type === 'image') {
						dados.current.content[order]['language'][langid]['media'][type] = [{ 
							id: '',
							link: res.data.path + '/' + res.data.name,
							name: res.data.name,
							description: '',
							type: type,
							order: order,
							lang: []
						}]
					}
					if(type === 'doc') {
						dados.current.content[order]['language'][langid]['media'][type].push({ 
							id: '',
							link: res.data.path + '/' + res.data.name,
							name: res.data.name,
							description: '',
							type: type,
							order: order,
							lang: []
						})
					}
				}

				reqPUT(api_crud_route, dados.current)
					.then(() => { 
						//props.history.push(endpoints.list) 
					})
					.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))

                reqPOST(`${api_crud_base}/multimedia`, x)
					.then(() => { 

                    })
					.catch(() => Swal.fire('Problema ao inserir Registo!', '', 'info'))
                
				return true

            })
            .catch(erro => console.log('Erro POST File: ' + erro))
    }

	const handle_change_info_date = (e) => {
		const { name, value } = e.target;
		
		set_dados(dados.current.info.date[name] = value)

		if(name === 'publication') {
			let date_publication = new Date(value); 
			set_date_publication(date_publication.getDate().toString().padStart(2, '0') + '/' + (date_publication.getMonth() + 1).toString().padStart(2, '0') + '/' + date_publication.getFullYear())
		}
		if(name === 'begin') {
			let date_begin = new Date(value); 
			set_date_begin(date_begin.getDate().toString().padStart(2, '0') + '/' + (date_begin.getMonth() + 1).toString().padStart(2, '0') + '/' + date_begin.getFullYear())
		}
		if(name === 'end') {
			let date_end = new Date(value); 
			set_date_end(date_end.getDate().toString().padStart(2, '0') + '/' + (date_end.getMonth() + 1).toString().padStart(2, '0') + '/' + date_end.getFullYear())
		}
		if(name === 'registration_begin') {
			let date_registration_begin = new Date(value); 
			set_date_registration_begin(date_registration_begin.getDate().toString().padStart(2, '0') + '/' + (date_registration_begin.getMonth() + 1).toString().padStart(2, '0') + '/' + date_registration_begin.getFullYear())
		}
		if(name === 'registration_deadline') {
			let date_registration_deadline = new Date(value); 
			set_date_registration_deadline(date_registration_deadline.getDate().toString().padStart(2, '0') + '/' + (date_registration_deadline.getMonth() + 1).toString().padStart(2, '0') + '/' + date_registration_deadline.getFullYear())
		}
		if(name === 'extension') {
			let date_extension = new Date(value); 
			set_date_extension(date_extension.getDate().toString().padStart(2, '0') + '/' + (date_extension.getMonth() + 1).toString().padStart(2, '0') + '/' + date_extension.getFullYear())
		}

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		console.log('Dados Current:' + JSON.stringify(dados))
	}

	const handle_change_tree = (tD, order, langid) => {

		treeData[order][langid] = tD

		let aux = []
		if(langid === '1') {
			treeData[order][langid].forEach((el) => {
				dados.current.content[order].media.doc.forEach((el_2) => {
					if(el.id_doc === el_2.id)
						aux.push(el_2)
				})
			});
			set_dados(dados.current.content[order].media.doc = aux)
			setTreeData(treeData)
		}
		else {
			treeData[order][langid].forEach((el) => {
				dados.current.content[order]['language'][langid].media.doc.forEach((el_2) => {
					if(el.id_doc === el_2.id)
						aux.push(el_2)
				})
			});
			set_dados(dados.current.content[order]['language'][langid].media.doc = aux)
			setTreeData(treeData)
		}

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}

	const remove_element_tree = (order, langid, id, doc) => {

		Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
		.then((result) => {
			if (result.isConfirmed) {

				let treeAux = treeData[order][langid].filter(v => v.id !== id)
				treeData[order][langid] = treeAux
				setTreeData(treeData)

				let aux = []
				if(langid === '1') {
					dados.current.content[order].media.doc.forEach((el) => {
						if(el.id !== doc)
							aux.push(el)
					})
					set_dados(dados.current.content[order].media.doc = aux)
				}
				else {
					dados.current.content[order]['language'][langid].media.doc.forEach((el) => {
						if(el.id !== doc)
							aux.push(el)
					})
					set_dados(dados.current.content[order]['language'][langid].media.doc = aux)
				}

			}
		})

		// console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
	}

	const edit_element_tree = (e) => {
		const { value, dataset } = e.target;
		const { order, /*id,*/ link } = dataset


		treeData[order].forEach((el) => {

			el.forEach(el_3 => {
				if(el_3.link === link) {
					el_3.title = value
	
					console.log('link', link)
					dados.current.content[order].media.doc.forEach((el_2) => {
						if(el_2.link === link)
							el_2.name = value
					})
				}
			})

			
		})
		set_dados(dados.current.content[order].media.doc, )


		console.log(dados.current.content[order].media.doc)
		setTreeData(treeData)
	}

	/*const handle_change_info_select = (e) => {
		const { name, value } = e.target;

		set_dados(dados.current.info[name]['id'] = value)
		set_dados(dados.current.info[name]['name'] = '')
	}*/

	const handleTagDelete = i => {
		console.log(i)
		let tags = dados.current.info['tags'].filter((tag, index) => index !== i)

		set_dados(dados.current.info['tags'] = tags)
	};
	
	const handleTagAddition = tag => {

		//console.log(tag)
		set_dados(dados.current.info['tags'].push(tag))

		let aux = suggestions.filter(v => v.id === tag.id)
		if(aux.length === 0) {
			let suggestions_aux = suggestions
			suggestions_aux.push(tag)
			set_suggestions(suggestions_aux)

			reqPOST(`${api_crud_base}/formation/category`, {id: '', info: {name: tag.text, color: '', lang:[], status: true, companycode: getTokenInfo().companycode}})
				.then(() => { 
					//console.log('Categoria inserida com sucesso!')
				})
				.catch(() => {
					//console.log('Problema ao inserir Categoria!')
				})
		}
	};

	const handleTagDrag = (tag, currPos, newPos) => {
		const newTags = tags.slice();

		newTags.splice(currPos, 1);
		newTags.splice(newPos, 0, tag);

		// re-render
		setTags(newTags);
	};

	const handleTagClick = index => {
		//console.log('The tag at index ' + index + ' was clicked');
	};

	/* FORMATION MODULES */

	const handle_change_content_module = (e) => {
		const { name, value } = e.target;

		//set_dados(dados.current.content[0][name] = value)

		if(name === 'module_name')
			set_module_name(value)
		if(name === 'module_sessions_number')
			set_module_sessions_number(value)
		if(name === 'module_evaluations_number')
			set_module_evaluations_number(value)
		if(name === 'module_evaluation')
			set_module_evaluation(value)
		if(name === 'module_duration')
			set_module_duration(value)
		if(name === 'module_description')
			set_module_description(value)
		if(name === 'module_objectives')
			set_module_objectives(value)

		console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		console.log('Dados Current:' + JSON.stringify(dados))
	}

	const handle_change_edit_content_module = (e) => {
		const { name, value, dataset } = e.target;
		const { index } = dataset;


		//set_dados(dados.current.content[0].modules[index][name] = value)

		dados.current.content[0].modules.forEach((el, i) => {

			let aux_index = '';
			aux_index = parseInt(index);

			if(i === aux_index) {

				el[name] = value

			}
			//console.log('name', el.name)
			//console.log('value', value)
				//el[name] = value
				//set_dados(dados.current.content[0].modules[index][name] = el[name]
		})

		set_dados(dados.current.content[0].modules)
		
		/*if(name === 'name') {
			set_dados(dados.current.content[0].modules[index].name = value)
		}
		else if(name === 'description') {
			set_dados(dados.current.info.cfp[index].descricao = value)
		}*/

		console.log('«««««««««««««««««««««««')
		console.log('Dados Current:' + JSON.stringify(dados))
	}

	const handle_change_content_module_ckeditor = (value, order, langid, lang, name) => {
	
		console.log('handle_change_info_ckeditor');

		if(langid === '1') {
			set_dados(dados.current.content[0].modules[order][name] = value)
		}
		else {
			if(dados.current.content[0].modules[order]['language'] === undefined)
				dados.current.content[0].modules[order]['language'] = []

			if(dados.current.content[0].modules[order].language.length  === 0) {
				dados.current.content[0].modules[order].language[langid] = {id: langid, code: lang, name: '', objectives: '', description: '', sessions_number: '', evaluations_number: '', evaluation: '', duration: ''}
			}

			set_dados(dados.current.content[0].modules[order]['language'][langid][name] = value)
		}

		console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		console.log('Dados Current:' + JSON.stringify(dados))
	}

	const handle_change_content_module_objectives_ckeditor_nolang = (e) => {

		//console.log(e)

		set_module_objectives(e)

		
		console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		console.log('Dados Current:' + JSON.stringify(dados))
	}

	const handle_change_content_module_ckeditor_nolang = (e) => {

		//console.log(e)

		set_module_description(e)

		
		console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		console.log('Dados Current:' + JSON.stringify(dados))
	}

	const handle_change_edit_content_module_with_lang = (e) => {
		const { name, value, dataset } = e.target;
		const { order, lang, langid } = dataset

		if(langid === '1') {
			set_dados(dados.current.content[0].modules[order][name] = value)
		}
		else {
			if(dados.current.content[0].modules[order]['language'] === undefined)
			dados.current.content[0].modules[order]['language'] = []

			if(dados.current.content[0].modules[order].language.length  === 0) {
				//dados.current.content[order].language[lang] = {id: langid, code: lang, title: '', abstract: '', text: ''}
				dados.current.content[0].modules[order].language[langid] = {id: langid, code: lang, name: '', description: '', sessions_number: '', evaluations_number: '', evaluation: '', duration: ''}
			}

			set_dados(dados.current.content[0].modules[order]['language'][langid][name] = value)
		}
		
		console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		console.log('Dados Current:' + JSON.stringify(dados))
	}

	const get_value_module_content_lang = (order, langid, name) => {
		if(dados.current.content[0].modules[order]['language'] !== undefined && dados.current.content[0].modules[order]['language'] !== null) {
			if(dados.current.content[0].modules[order]['language'][langid] !== undefined && dados.current.content[0].modules[order]['language'][langid] !== null) {
				return dados.current.content[0].modules[order]['language'][langid][name];
			}
			else {
				return '';
			}
		}
		else {
			return '';
		}
	}

	const add_new_module = () => {

		if(module_name !== '' && module_description !== '') {

			if(dados.current.content[0].modules === undefined) {
				dados.current.content[0].modules = []
			}

			var today_submit = new Date()
			
			Swal.fire({
				title: language[lang].edit_title,
				text: language[lang].edit_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].edit_confirm,
				cancelButtonText: language[lang].edit_cancel
			})
			.then((result) => {
				if (result.isConfirmed) {

					set_dados(dados.current.content[0].modules.push(
						{ 
							id: dados.current.content[0].modules.length + 1,
							name: module_name,
							objectives: module_objectives,
							description: module_description,
							sessions_number: module_sessions_number,
							evaluations_number: module_evaluations_number,
							evaluation: module_evaluation,
							duration: module_duration
		
						}
					));

					files_image.forEach(async (el_image) => {
						if(el_image !== null) {
							await uploadFilesImage(el_image.files, el_image.order, 'image', el_image.langid, el_image.lang)
						}
					})
					set_files_image([])

					files_doc.forEach(async (el_doc) => {
						if(el_doc !== null) {
							await uploadFilesDoc(el_doc.files, el_doc.order, 'doc', el_doc.langid, el_doc.lang)
						}
					})
					set_files_doc([])
					set_files_doc_name([])

					dados.current.info.date.modified.push(today_submit)
					reqPUT(api_crud_route, dados.current)
						.then(() => { 
							//props.history.push(endpoints.list) 
						})
						.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))

					set_module_name('')
					set_module_sessions_number('')
					set_module_evaluations_number('')
					set_module_evaluation('')
					set_module_duration('')
					set_module_description('')
					set_module_objectives('')

				}
			})
			
			/*set_dados(dados.current.content[0].modules.push(
				{ 
					id: dados.current.content[0].modules.length + 1,
					name: module_name,
					description: module_description,
					sessions_number: module_sessions_number,
					evaluation: module_evaluation,
					duration: module_duration

				}
			));*/

			//save_modules()
		
			/*set_module_name('')
			set_module_sessions_number('')
			set_module_evaluation('')
			set_module_duration('')
			set_module_description('')*/
			

		}
		else {
			//alert( language[lang].module_insert_error )
			Swal.fire(language[lang].module_add, language[lang].module_insert_error, 'error')
		}

		//console.log('«««««««««««««««««««««««')
		//console.log('Dados Current:' + JSON.stringify(dados))
	}

	const save_modules = () => {

		var today_submit = new Date()
			
		Swal.fire({
			title: language[lang].edit_title,
			text: language[lang].edit_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].edit_confirm,
			cancelButtonText: language[lang].edit_cancel
		})
		.then((result) => {
			if (result.isConfirmed) {

				files_image.forEach(async (el_image) => {
					if(el_image !== null) {
						await uploadFilesImage(el_image.files, el_image.order, 'image', el_image.langid, el_image.lang)
					}
				})
				set_files_image([])

				files_doc.forEach(async (el_doc) => {
					if(el_doc !== null) {
						await uploadFilesDoc(el_doc.files, el_doc.order, 'doc', el_doc.langid, el_doc.lang)
					}
				})
				set_files_doc([])
				set_files_doc_name([])

				dados.current.info.date.modified.push(today_submit)
				reqPUT(api_crud_route, dados.current)
					.then(() => { 
						//props.history.push(endpoints.list) 
					})
					.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))

				set_module_name('')
				set_module_sessions_number('')
				set_module_evaluations_number('')
				set_module_evaluation('')
				set_module_duration('')
				set_module_description('')
				set_module_objectives('')
			}
		})

		//console.log('«««««««««««««««««««««««')
		//console.log('Dados Current:' + JSON.stringify(dados))
	}

	const removeInputModule = (index) => {

		Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
		.then((result) => {
			if (result.isConfirmed) {

				//DELETE MODULE

				let del_value = dados.current.content[0].modules.slice(index, index + 1);
				//console.log('Módulo a apagar: ', del_value);
				//console.log('nome do Módulo a apagar: ', del_value[0].name);

				let modules = dados.current.content[0].modules.filter(v => v.name !== del_value[0].name);
				//console.log('Módulos actualizados: ', modules);

				set_dados(dados.current.content[0].modules = modules)


				//SAVE
				var today_submit = new Date()

				files_image.forEach(async (el_image) => {
					if(el_image !== null) {
						await uploadFilesImage(el_image.files, el_image.order, 'image', el_image.langid, el_image.lang)
					}
				})
				set_files_image([])

				files_doc.forEach(async (el_doc) => {
					if(el_doc !== null) {
						await uploadFilesDoc(el_doc.files, el_doc.order, 'doc', el_doc.langid, el_doc.lang)
					}
				})
				set_files_doc([])
				set_files_doc_name([])

				dados.current.info.date.modified.push(today_submit)
				reqPUT(api_crud_route, dados.current)
					.then(() => { 
						//props.history.push(endpoints.list) 
					})
					.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))
				
				//console.log('«««««««««««««««««««««««')
				//console.log('Dados Current:' + JSON.stringify(dados))
			}
		})

	};

	// TRAINER
	const [trainers, set_trainers] = useState([]);
	const [trainer_selected, set_selected_trainer] = useState({label: '', value: '', email:'', username: ''})
	const get_trainers = async () => {
		let aTrainers = [];

		reqGET(`${api_crud_base}/entities/list/${getTokenInfo().companycode}/trainer_user`)
			.then(res => {
				res.data.forEach(v => {
					aTrainers.push({ label: v.name + ' ' + v.surname, value: v.id, email: v.email, username: v.username })
				});					

				set_trainers(aTrainers)
			})
			.catch( erro => { console.log( erro ) ; alert( 'Erro' ) ; } )
	}

	const add_trainer = () => {
		
		let trainer = trainers.filter(v => v.label === trainer_selected.label);
		

		if(trainer.length === 0) {

		}
		else {

			if(dados.current.info['trainers'] === undefined)
				dados.current.info['trainers'] = []

			dados.current.info.trainers.forEach(v => {

				if(v.id === trainer_selected.value){
					//alert('este formador já foi adicionado a esta formação')
					Swal.fire(language[lang].add_trainer, language[lang].add_trainer_error, 'error')
					set_selected_trainer({label: '', value: '', email:'', username:'' })
					trainer = [];
				}
			});

			
			if(trainer.length !== 0){
				set_dados(dados.current.info.trainers.push(
					{ 
						
						id:  trainer_selected.value,
						name: trainer_selected.label,
						email: trainer_selected.email,
						username: trainer_selected.username,
						notified: false,
						
					}
				));
			}

			console.log('Dados Add Trainer:' + JSON.stringify(dados))
		}
	

		set_selected_trainer({label: '', value: '', email:'', username:'' })
	}

	const removeInputTrainer = (index) => {
		
		let del_value = dados.current.info.trainers.slice(index, index + 1);
		//console.log('TESTE REMOVE', dados.current.info.trainers)
		let trainers = dados.current.info.trainers.filter(v => v.id !== del_value[0].id);

		set_dados(dados.current.info.trainers = trainers)

	};

	const handle_selected_trainers = (e) => {


		//console.log('selected value', e)
		const { label, value, email, username } = e;
		
		set_selected_trainer({label: label, value: value, email: email, username: username })
	}
	

	/* end FORMATION MODULES */


	return isloading ?
		
		<Loader />
		
		:

		<main>
			<form id="form" onSubmit={handleSubmit}>
				<input type="hidden" name="id" value={dados.current.id} />

				<div className={`dash-cards header`}>
					<h2 className="dash-title">{language[lang].content}</h2>
					<span>
						<Link to={{ pathname: endpoints.list }}  >
							{language[lang].content}
						</Link>
						&nbsp;&#47;&nbsp;
						{dados.current.id !== '' ? language[lang].content_edit : language[lang].content_new}
					</span>
				</div>
		
				<div className={`dash-cards body`}>
					<div className="container">
						<div className="row">

							<div className="col-md-8 mb-3">

								{
								dados.current.content.length > 1 ?
									(
									<div className="mb-5">
										<div className="card mb-5">
										
											<div className="card-header border-0">
												<ul className="nav nav-tabs nav-line-tabs border-bottom-0 mt-2 mb-1 fs-6">
													{
													dados.current.content.map((el, k) => {
														return (
															<li key={k} className="nav-item mb-1">
																<a className={"btn btn-sm btn-secondary" + (k === 0 ? " active" : "")} data-bs-toggle="tab" href={"#kt_tab_pane_content_" + k}>{k + 1}</a>
															</li>

														)
													})
													}
												</ul>
											</div>

										</div>
									</div>
									)
								:
									''
								}

								<div className="tab-content" id="tabContent">
									{
									dados.current.content.map((el, k) => {
										return (
											<div key={k} className={"tab-pane " + (k === 0 ? " show active" : '')} id={"kt_tab_pane_content_" + k} role="tabpanel">

												<div className="card">
													<div className="card-header border-0 d-flex justify-content-sm-between">
														<div className="card-title m-0">
															<h3 className="fw-bolder m-0">{language[lang].content} {/*k + 1*/}</h3>
														</div>
														<div className="card-toolbar">
															<ul className="nav nav-tabs nav-line-tabs nav-stretch fs-6 border-0">
																{
																content_language.length > 1 ?
																	content_language.map((el_lang, k_lang) => {
																		return (
																			<li key={k_lang} className="nav-item">
																				<a className={"btn btn-sm btn-secondary rounded-0 multi-item" + (k_lang === 0 ? " active" : "")} data-bs-toggle="tab" href={"#kt_tab_pane_content_" + k + "_language_" + k_lang}>{el_lang.code}</a>
																			</li>
																		)
																	})
																:
																	''
																}
															</ul>
														</div>
													</div>
													<div id="kt_content" >
														<div className="card-body border-top p-3">
															<div className="tab-content" id={"tabContentLang_" + k} >
																{
																content_language.length > 1 ?
																	content_language.map((el_lang, k_lang) => {
																		return (
																			<div key={k_lang} className={"tab-pane" + (k_lang === 0 ? " show active" : '')} id={"kt_tab_pane_content_" + k +  "_language_" + k_lang} role="tabpanel">

																				<div className="row mb-3">
																					<div className="col-12 mb-2">
																						<label className={k === 0 && el_lang.id === '1' ? "col-form-label required fw-bold fs-6" : "col-form-label fw-bold fs-6"}>{language[lang].field_title} {k_lang > 0 ? '(' + el_lang.code + ')' : ''}</label>
																						<input type="text" name="title" data-order={k} data-langid={el_lang.id} data-lang={el_lang.code} value={el_lang.id === '1' ? el.title : get_value_content_lang(k, el_lang.id, 'title') } className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].field_title_placeholder} onChange={handle_change_content} required={k === 0 && el_lang.id === '1' ? 'required' : ''} />
																					</div>
																					{
																						is_edit === true ?
																							<div className="col-12 mb-2">
																								<LinkScroll activeClass="active" to="modules" spy={true} smooth={true} offset={-150} duration={500} className="btn btn-secondary" alt={language[lang].module_add} title={language[lang].module_add}>
																									<img className="assec-mr-15" alt={language[lang].module_add} title={language[lang].module_add} src={'./img/plus.svg'} />
																									{language[lang].module_add}
																								</LinkScroll>
																								{
																									dados.current.content[0].modules.length > 0 ?
																										<LinkScroll activeClass="active" to="accordion_modules" spy={true} smooth={true} offset={-150} duration={500} className="btn btn-secondary ms-2" alt={language[lang].modules_view} title={language[lang].modules_view}>
																											<i className="bi bi-eye text-white me-2"></i>
																											{language[lang].modules_view}
																										</LinkScroll>
																									: null
																								}
																							</div>
																						: null
																					}

																					<div className="col-12 mb-2">
																						<label className="col-form-label fw-bold fs-6">{language[lang].objectives} {k_lang > 0 ? '(' + el_lang.code + ')' : ''}</label>

																						<AssecCKEditor
																							name={"abstract-" + k}
																							content={el_lang.id === '1' ? el.abstract : get_value_content_lang(k, el_lang.id, 'abstract')}
																							func={(e) => handle_change_content_ckeditor(e, k, el_lang.id, el_lang.code, 'abstract')}
																						/>

																						<textarea className="form-control mb-3 mb-lg-0 rounded-0 d-none" name="text" data-order={k} data-langid={el_lang.id} data-lang={el_lang.code} value={el_lang.id === '1' ? el.text : get_value_content_lang(k, el_lang.id, 'text') } rows="8" onChange={handle_change_content} />
																					</div>

																					<div className="col-12 mb-2">
																						<label className="col-form-label fw-bold fs-6">{language[lang].field_description} {k_lang > 0 ? '(' + el_lang.code + ')' : ''}</label>

																						<AssecCKEditor
																							name={"text-" + k}
																							content={el_lang.id === '1' ? el.text : get_value_content_lang(k, el_lang.id, 'text')}
																							func={(e) => handle_change_content_ckeditor(e, k, el_lang.id, el_lang.code, 'text')}
																						/>

																						<textarea className="form-control mb-3 mb-lg-0 rounded-0 d-none" name="text" data-order={k} data-langid={el_lang.id} data-lang={el_lang.code} value={el_lang.id === '1' ? el.text : get_value_content_lang(k, el_lang.id, 'text') } rows="8" onChange={handle_change_content} />
																					</div>

																					<div className="col-12 mb-2">
																						<label className="col-form-label fw-bold fs-6">{language[lang].target_audience} {k_lang > 0 ? '(' + el_lang.code + ')' : ''}</label>
																						<AssecCKEditor
																							name={"target-" + k}
																							content={el_lang.id === '1' ? el.target : get_value_content_lang(k, el_lang.id, 'target')}
																							func={(e) => handle_change_content_ckeditor(e, k, el_lang.id, el_lang.code, 'target')}
																						/>
																						{/*<input type="text" name="target" data-order={k} data-langid={el_lang.id} data-lang={el_lang.code} value={el_lang.id === '1' ? el.target : get_value_content_lang(k, el_lang.id, 'target') } className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].target_placeholder} onChange={handle_change_content} />*/}
																						<textarea className="form-control mb-3 mb-lg-0 rounded-0 d-none" name="target" data-order={k} data-langid={el_lang.id} data-lang={el_lang.code} value={el_lang.id === '1' ? el.target : get_value_content_lang(k, el_lang.id, 'target') } rows="6" onChange={handle_change_content} />
																					</div>
																				</div>

																				<div className="row mb-3">	
																					<div className="col-12 col-sm-6 d-none">
																						<label className="col-form-label fw-bold fs-6">{language[lang].formation_date_start} {k_lang > 0 ? '(' + el_lang.code + ')' : ''}</label>
																						<input type="datetime-local" name="start_date" value={dados.current.content[0].start_date !== '' ? dados.current.content[0].start_date: ''} className="form-control mb-3 mb-lg-0 rounded-0" onChange={handle_change_content_nolang} />
																					</div>
																					<div className="col-12 col-sm-6 d-none">
																						<label className="col-form-label fw-bold fs-6">{language[lang].formation_date_end} {k_lang > 0 ? '(' + el_lang.code + ')' : ''}</label>
																						<input type="datetime-local" name="end_date"  value={dados.current.content[0].end_date !== '' ? dados.current.content[0].end_date: ''} className="form-control mb-3 mb-lg-0 rounded-0" onChange={handle_change_content_nolang} />
																					</div>																			
																					<div className="col-12 mb-3">
																						<div className="row">
																							<label className="col-form-label fw-bold fs-6">{language[lang].formation_language}{k_lang > 0 ? '(' + el_lang.code + ')' : ''}</label>
																							<div className="col-3">
																								<input
																									id={"formation_lang_" + k_lang + "_01"}
																									type="radio"
																									name={"formation_lang_" + k_lang}
																									value="formation_language_pt"
																									/*data-order={k}
																									data-langid={el_lang.id}
																									data-lang={el_lang.code}*/
																									className={dados.current.content[0].formation_lang}
																									checked={dados.current.content[0].formation_lang === 'formation_language_pt' ? true : false}
																									onChange={handle_change_content_language}
																								/>
																								<span className="checkmark"></span>
																								<label className="assec-pl-5" htmlFor={"formation_lang_" + k_lang + "_01"}>{language[lang].formation_language_pt}</label>
																							</div>
																							<div className="col-3">
																								<input
																									id={"formation_lang_" + k_lang + "_02"}
																									type="radio"
																									name={"formation_lang_" + k_lang}
																									value="formation_language_en"
																									/*data-order={k}
																									data-langid={el_lang.id}
																									data-lang={el_lang.code}*/
																									checked={dados.current.content[0].formation_lang === 'formation_language_en' ? true : false}
																									onChange={handle_change_content_language}
																								/>
																								<span className="checkmark"></span>
																								<label className="assec-pl-5" htmlFor={"formation_lang_" + k_lang + "_02"}>{language[lang].formation_language_en}</label>
																							</div>
																							<div className="col-3">
																								<input
																									id={"formation_lang_" + k_lang + "_03"}
																									type="radio"
																									name={"formation_lang_" + k_lang}
																									value="formation_language_es"
																									/*data-order={k}
																									data-langid={el_lang.id}
																									data-lang={el_lang.code}*/
																									checked={dados.current.content[0].formation_lang === 'formation_language_es' ? true : false}
																									onChange={handle_change_content_language}
																								/>
																								<span className="checkmark"></span>
																								<label className="assec-pl-5" htmlFor={"formation_lang_" + k_lang + "_03"}>{language[lang].formation_language_es}</label>
																							</div>
																						</div>
																					</div>
																					<div className="col-12">
																						<div className="row">
																							<label className="col-form-label fw-bold fs-6">{language[lang].financing}{k_lang > 0 ? '(' + el_lang.code + ')' : ''}</label>
																							<div className="col-3">
																								<input
																									id={"financing_" + k_lang + "_01"}
																									type="radio"
																									name={"financing_" + k_lang}
																									value="financing_financed"
																									checked={dados.current.content[0].financing === 'financing_financed' ? true : false}
																									onChange={handle_change_content_financing}
																								/>
																								<span className="checkmark"></span>
																								<label className="assec-pl-5" htmlFor={"financing_" + k_lang + "_01"}>{language[lang].financing_financed}</label>
																							</div>
																							<div className="col-3">
																								<input
																									id={"financing_" + k_lang + "_02"}
																									type="radio"
																									name={"financing_" + k_lang}
																									value="financing_free"
																									checked={dados.current.content[0].financing === 'financing_free' ? true : false}
																									onChange={handle_change_content_financing}
																								/>
																								<span className="checkmark"></span>
																								<label className="assec-pl-5" htmlFor={"financing_" + k_lang + "_02"}>{language[lang].financing_free}</label>
																							</div>
																							<div className="col-3">
																								<input
																									id={"financing_" + k_lang + "_03"}
																									type="radio"
																									name={"financing_" + k_lang}
																									value="financing_paid"
																									checked={dados.current.content[0].financing === 'financing_paid' ? true : false}
																									onChange={handle_change_content_financing}
																								/>
																								<span className="checkmark"></span>
																								<label className="assec-pl-5" htmlFor={"financing_" + k_lang + "_03"}>{language[lang].financing_paid}</label>
																							</div>
																						</div>
																					</div>
																					{
																						dados.current.content[0].financing === 'financing_paid' ?

																							<div className="col-12 mb-2">
																								<div className="row">
																									<div className="col-6">
																										<label className="col-form-label fw-bold fs-6">{language[lang].formation_value} {k_lang > 0 ? '(' + el_lang.code + ')' : ''}</label>
																										<div className='input-group'>
																											<input type="number" name="price" value={dados.current.content[0].price} className="form-control mb-3 mb-lg-0 rounded-0" aria-describedby="default-euro" placeholder={language[lang].formation_value_placeholder} onChange={handle_change_content_nolang} />
																											<span className="input-group-text" id="default-euro">&euro;</span>
																										</div>
																									</div>
																								</div>
																							</div>
																						: null
																					}

																				</div>

																				<div className="row mb-3">
																					
																					<div className="col-6 mb-2 d-none">
																						<label className="col-form-label fw-bold fs-6">{language[lang].sessions_number} {k_lang > 0 ? '(' + el_lang.code + ')' : ''}</label>
																						<input type="number" name="sessions" value={dados.current.content[0].sessions} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].sessions_placeholder} onChange={handle_change_content_nolang} />
																					</div>
																					<div className="col-6 mb-2">
																						<label className="col-form-label fw-bold fs-6">{language[lang].formation_modality} {k_lang > 0 ? '(' + el_lang.code + ')' : ''}</label>
																						
																						<select className="form-select rounded-0" aria-label="Select Modality" name='modality' value={dados.current.content[0].modality} onChange={handle_change_content_nolang}>
																							<option value="formation_modality_classroom">{language[lang].formation_modality_classroom}</option>
																							<option value="formation_modality_online">{language[lang].formation_modality_online}</option>
																							<option value="formation_modality_mixed">{language[lang].formation_modality_mixed}</option>
																						</select>
																					</div>
																					<div className="col-6 mb-2">
																						<label className="col-form-label fw-bold fs-6">{language[lang].formation_schedule} {k_lang > 0 ? '(' + el_lang.code + ')' : ''}</label>
																						
																						<select className="form-select rounded-0" aria-label="Select Schedule" name='schedule' value={dados.current.content[0].schedule} onChange={handle_change_content_nolang}>
																							<option value="formation_schedule_working_hours">{language[lang].formation_schedule_working_hours}</option>
																							<option value="formation_schedule_post_work">{language[lang].formation_schedule_post_work}</option>
																							<option value="formation_schedule_flexible">{language[lang].formation_schedule_flexible}</option>
																						</select>
																					</div>
																					<div className="col-6 mb-2">
																						<label className="col-form-label fw-bold fs-6">{language[lang].duration} {k_lang > 0 ? '(' + el_lang.code + ')' : ''}</label>
																						<input type="number" name="duration" value={dados.current.content[0].duration} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].duration_placeholder} onChange={handle_change_content_nolang} />
																					</div>
																					<div className="col-6 mb-2">
																						<label className="col-form-label fw-bold fs-6">{language[lang].available_vacancies} {k_lang > 0 ? '(' + el_lang.code + ')' : ''}</label>
																						<input type="number" name="vacancies" value={dados.current.content[0].vacancies} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].available_vacancies_placeholder} onChange={handle_change_content_nolang} />
																					</div>
																				</div>

																				<div className="row mb-3">
																					<div className="col-12">
																						<div className="div-image">
																							<label className="col-form-label fw-bold fs-6">{language[lang].images}</label>

																							<div className="dropzone-panel mb-2">
																								<div className="div-form-input col-12 custom-file">
																									<label className="dropzone-select btn btn-sm btn-secondary rounded-0 me-2 dz-clickable" htmlFor={"input-files-content-" + k + "-" + el_lang.id}>{language[lang].image_choose}</label>
																									<input 
																										id={"input-files-content-" + k + "-" + el_lang.id}
																										type="file" 
																										accept="image/*"
																										data-order={k}
																										data-langid={el_lang.id}
																										data-lang={el_lang.code}
																										data-type={'image'}
																										className="dropzone-select btn btn-sm btn-primary me-2 d-none" 
																										onChange={onChangeHandlerFilesImage}
																									/> 
																								</div>
																							</div>

																							<button type="button" className="btn btn-sm btn-primary mb-5 d-none" data-bs-toggle="modal" data-bs-target={"#kt_modal_media_image_bloco_" + k}>
																								{language[lang].image_choose}
																							</button>

																							<div className="row">
																								{
																								el_lang.id === '1' && el['media'] !== undefined && el['media']['image'] !== undefined ?
																									<>
																										{
																										el['media']['image'].map((el_media, k_media) => {
																											return (
																												<DraggableDivImage 
																													key={k_media}
																													divNumber={k_media}
																													idImage={el_media.id}
																													linkImage={el_media.link}
																													nameImage={el_media.name}
																													descImage={el_media['description']}
																													contentOrder={k}
																													language={language}
																													lang={lang}

																													handleDrag={handleDrag}
																													handleDragOver={handleDrop}
																													//handleDrop={handleDrop}
																													handleDrop={(e) => console.log('drop)')}
																													handleRemove={(e) => handleRemove(k, el_lang.id, el_media.id, el_media.link)}
																													handleEdit={(e) => handleEdit(k)}
																													handleChangeContentMediaImage={(e) => handleChangeContentMediaImage(e)}
																												/>
																											)
																										}) 
																										}

																										{
																										image_base64[k] !== undefined && image_base64[k][el_lang.id] !== undefined ?
																											image_base64[k][el_lang.id].map((el_media, k_media) => {
																												return (
																													<DraggableDivImage 
																														key={k_media}
																														divNumber={k_media}
																														idImage={el_media.id}
																														linkImage={el_media.link}
																														nameImage={el_media.name}
																														descImage={el_media['description']}
																														contentOrder={k}
																														language={language}
																														lang={lang}

																														handleDrag={handleDrag}
																														handleDragOver={handleDrop}
																														//handleDrop={handleDrop}
																														handleDrop={(e) => console.log('drop)')}
																														handleRemove={(e) => handleRemove(k, el_lang.id, el_media.id, el_media.link)}
																														handleEdit={(e) => handleEdit(k)}
																														handleChangeContentMediaImage={(e) => handleChangeContentMediaImage(e)}
																													/>
																												)
																											}) 
																										:
																											null
																										}
																									</>
																								: 
																									(
																									el['language'] !== undefined && el['language'].length > 0 && el['language'][el_lang.id]['media'] !== undefined && el['language'][el_lang.id]['media']['image'] !== undefined ?
																										<>
																											{
																											el['language'][el_lang.id]['media']['image'].map((el_media, k_media) => {

																												return (
																													<DraggableDivImage 
																														key={k_media}
																														divNumber={k_media}
																														idImage={el_media.id}
																														linkImage={el_media.link}
																														nameImage={el_media.name}
																														descImage={el_media['description']}
																														contentOrder={k}
																														language={language}
																														lang={lang}

																														handleDrag={handleDrag}
																														handleDrop={handleDrop}
																														handleRemove={(e) => handleRemove(k, el_lang.id, el_media.id, el_media.link)}
																														handleEdit={(e) => handleEdit(k)}
																														handleChangeContentMediaImage={(e) => handleChangeContentMediaImage(e)}
																													/>
																												)
																											})
																											}

																											{
																											image_base64[k] !== undefined && image_base64[k][el_lang.id] !== undefined ?
																												image_base64[k][el_lang.id].map((el_media, k_media) => {
																													return (
																														<DraggableDivImage 
																															key={k_media}
																															divNumber={k_media}
																															idImage={el_media.id}
																															linkImage={el_media.link}
																															nameImage={el_media.name}
																															descImage={el_media['description']}
																															contentOrder={k}
																															language={language}
																															lang={lang}

																															handleDrag={handleDrag}
																															handleDragOver={handleDrop}
																															//handleDrop={handleDrop}
																															handleDrop={(e) => console.log('drop)')}
																															handleRemove={(e) => handleRemove(k, el_lang.id, el_media.id, el_media.link)}
																															handleEdit={(e) => handleEdit(k)}
																															handleChangeContentMediaImage={(e) => handleChangeContentMediaImage(e)}
																														/>
																													)
																												}) 
																											:
																												null
																											}
																										</>
																									: 
																										''
																									) 
																								}
																							</div>
																						</div>
																					</div>
																				</div>

																				<div className="row mb-3">
																					<div className="col-12">
																						<div className="div-doc">
																							<label className="col-form-label fw-bold fs-6">{language[lang].pdf_documents}</label>

																							<div className="dropzone-panel mb-lg-0 mb-2">
																								<div className="div-form-input col-12 custom-file">
																									<label className="dropzone-select btn btn-sm btn-secondary rounded-0 me-2 dz-clickable" htmlFor={"input-files-pdf-" + k + '-' + el_lang.id}>{language[lang].doc_choose}</label>
																									<input 
																										id={"input-files-pdf-" + k + '-' + el_lang.id}
																										type="file" 
																										accept="application/pdf"
																										data-order={k}
																										data-langid={el_lang.id}
																										data-lang={el_lang.code}
																										data-type={'doc'}
																										className="dropzone-select btn btn-sm btn-primary me-2 d-none" 
																										onChange={onChangeHandlerFilesPDF}
																										multiple
																									/> 
																								</div>
																							</div>

																							<div className="row">
																								{
																								treeData[k] !== undefined && treeData[k][el_lang.id] !== undefined ?
																									<SortableTree
																										isVirtualized={false}
																										treeData={treeData[k][el_lang.id]}
																										maxDepth={1}
																										//onChange={() => console.log('onChange')}
																										onChange={treeData => handle_change_tree(treeData, k, el_lang.id)}
																										getNodeKey={({ node }) => node.id}
																										generateNodeProps={extendedNode => ({
																											title: (
																												<input type="text" className="form-control form-control-sm" defaultValue={extendedNode.node.title} data-order={k} data-id={extendedNode.node.id} data-doc={extendedNode.node.id_doc} data-link={extendedNode.node.link} onBlur={edit_element_tree} />
																											),
																											buttons: [
																												<button type="button" onClick={() => console.log('link')} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="link"><i className="bi bi-link"></i></button>,
																												<button type="button" onClick={() => console.log('clipboard')} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm d-none" title="clipboard"><i className="bi bi-clipboard"></i></button>,
																												<button type="button" onClick={() => console.log('eye')} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm d-none" title="eye"><i className={"bi bi-eye" + (extendedNode.node.visible === true ? '' : '-slash' )}></i></button>,
																												<button type="button" onClick={() => remove_element_tree(k, el_lang.id, extendedNode.node.id, extendedNode.node.id_doc)} className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm" title="remove"><i className="bi bi-trash-fill"></i></button>,
																											],
																										})}
																									/>
																								: 
																									''
																								}
																							</div>
																						</div>
																					</div>
																					{
																						is_edit === false ?
																							<div className='col-12 mt-5'>
																								<label className="col-form-label fw-bold fs-6">{language[lang].module_add_info}</label>
																							</div>
																						: ''
																					}
																				</div>
																			</div>
																		)
																	})
																: 
																	''
																}
															</div>
														</div>
													</div>
												</div>
											</div>
											)
										})
									}
								</div>
								
							</div>

							<div className="col-md-4 mb-3">

								<div className="card mb-5">
									<div className="card-header border-0 cursor-pointer" role="button" data-bs-toggle="collapse" data-bs-target="#div_configuracao" aria-expanded="true" aria-controls="div_configuracao">
										<div className="card-title m-0">
											<h3 className="fw-bolder m-0">{language[lang].page_config}</h3>
										</div>
									</div>
									<div id="div_configuracao" className="collapse show">
										<div className="card-body border-top p-3">
											
											<div className="mb-3">
												<label className="col-form-label required fw-bold fs-6">{language[lang].field_name}</label>
												<input type="text" name="name" value={dados.current.info ? dados.current.info.name : ''} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].field_name_placeholder} onChange={handle_change_info} required />
											</div>

											<div className="mb-3">
												<label className="col-form-label required fw-bold fs-6">{language[lang].table_state}</label>
												<div>
													<input
														id="radio_1"
														type="radio"
														name="status"
														value="with_emphasis"
														defaultChecked={dados.current.info.status === 'with_emphasis' ? true : false}
														onChange={handle_change_info}
													/>
													<span className="checkmark"></span>
													<label className="assec-pl-5" htmlFor="radio_1">{language[lang].with_emphasis}</label>
												</div>
												<div>
													<input
														id="radio_0"
														type="radio"
														name="status"
														value="without_emphasis"
														defaultChecked={dados.current.info.status === 'without_emphasis' ? true : false}
														onChange={handle_change_info}
													/>
													<span className="checkmark"></span>
													<label className="assec-pl-5" htmlFor="radio_0">{language[lang].without_emphasis}</label>
												</div>
											</div>

											<div className="mb-3">
												<label className="col-form-label fw-bold fs-6">Categorias</label>
												<ReactTags
													//tags={dados.current.info['tags'] !== undefined ? dados.current.info['tags'] : []}
													className={"form-control rounded-0 mb-3 mb-lg-0"}
													suggestions={suggestions}
													delimiters={delimiters}
													handleDelete={handleTagDelete}
													handleAddition={handleTagAddition}
													handleDrag={handleTagDrag}
													handleTagClick={handleTagClick}
													//inputFieldPosition="top"
													placeholder={language[lang].choose_category}
													autocomplete
												/>
												{
												dados.current.info['tags'] !== undefined ? 
													dados.current.info['tags'].map((t, k) => {
														return (
															<div key={k} className="badge bg-secondary rounded-0 mt-1 me-1">
																<span className='me-2'>{t.text}</span>
																<span className='cursor-pointer' onClick={() => handleTagDelete(k)}>
																	<i className="bi bi-x"></i>
																</span>
															</div>
														)
													})
												: ''
												}
											</div>

											<div className="mb-3">
												<label className="col-form-label fw-bold fs-6">Slug do URL <small>(friendly url)</small></label>
												<div className="input-group input-group-sm mb-5 p-0">
													<span className="input-group-text rounded-0" id="basic-addon3">formation/</span>
													<input type="text" name="slug" value={dados.current.info ? dados.current.info.slug : ''} onChange={handle_change_info} onBlur={handle_change_info_slug} className="form-control rounded-0" id="basic-url" aria-describedby="basic-addon3" />
												</div>
											</div>

											<div className="">
												<label className="col-form-label fw-bold fs-6">{language[lang].date_publication}</label>
												
												<input type="datetime-local" className="form-control rounded-0" name="publication" value={dados.current.info.date.publication !== '' ? dados.current.info.date.publication : ''} onChange={handle_change_info_date} />
											</div>
											<div className="">
												<label className="col-form-label fw-bold fs-6">{language[lang].date_begin}</label>
												
												<input type="datetime-local" className="form-control rounded-0" name="begin" value={dados.current.info.date.begin !== '' ? dados.current.info.date.begin : ''} onChange={handle_change_info_date} />
											</div>
											<div className="">
												<label className="col-form-label fw-bold fs-6">{language[lang].date_end}</label>
												
												<input type="datetime-local" className="form-control rounded-0" name="end" value={dados.current.info.date.end !== '' ? dados.current.info.date.end : ''} onChange={handle_change_info_date} />
											</div>
											
											<div className="">
												<label className="col-form-label fw-bold fs-6">{language[lang].date_extension}</label>
												
												<input type="datetime-local" className="form-control rounded-0" name="extension" value={dados.current.info.date.extension !== '' ? dados.current.info.date.extension : ''} onChange={handle_change_info_date} />
											</div>
											<div className="">
												<label className="col-form-label fw-bold fs-6">{language[lang].date_registration_begin}</label>
												
												<input type="datetime-local" className="form-control rounded-0" name="registration_begin" value={dados.current.info.date.registration_begin !== '' ? dados.current.info.date.registration_begin : ''} onChange={handle_change_info_date} />
											</div>
											<div className="mb-3">
												<label className="col-form-label fw-bold fs-6">{language[lang].date_registration_deadline}</label>
												
												<input type="datetime-local" className="form-control rounded-0" name="registration_deadline" value={dados.current.info.date.registration_deadline !== '' ? dados.current.info.date.registration_deadline : ''} onChange={handle_change_info_date} required />
											</div>

											<div className="mb-3">
												<label className="col-form-label fw-bold fs-6">{language[lang].dates}</label>
												<p>
													{/*<strong>{language[lang].date_creation}:</strong> {date_creation !== '' ? date_creation : ''}<br />*/}
													<strong>{language[lang].date_publication}:</strong> {date_publication !== '' ? date_publication : ''}<br />
													<strong>{language[lang].date_begin}:</strong> {date_begin !== '' ? date_begin : ''}<br />
													<strong>{language[lang].date_end}:</strong> {date_end !== '' ? date_end : ''}<br />
													<strong>{language[lang].date_extension}:</strong> {date_extension !== '' ? date_extension : ''}<br />
													<strong>{language[lang].date_registration_begin}:</strong> {date_registration_begin !== '' ? date_registration_begin : ''}<br />
													<strong>{language[lang].date_registration_deadline}:</strong> {date_registration_deadline !== '' ? date_registration_deadline : ''}<br />
													{/*<strong>{language[lang].date_last_update}:</strong> {date_modification !== '' ? date_modification : ''}*/}
												</p>
											</div>
										</div>
									</div>
								</div>
								
								<div className="card mb-3">
									<div className="card-header border-0 cursor-pointer" role="button" data-bs-toggle="collapse" data-bs-target="#div_seo" aria-expanded="true" aria-controls="div_seo">
										<div className="card-title m-0">
											<h3 className="fw-bolder m-0">{language[lang].seo_config}</h3>
										</div>
									</div>
									<div id="div_seo" className="collapse show">
										<div className="card-body border-top p-3">
											<div className="mb-3">
												<label className="col-form-label fw-bold fs-6">{language[lang].seo_title}</label>
												<input type="text" name="title" value={dados.current.info.seo ? dados.current.info.seo.title : ''} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].seo_title_placeholder} onChange={handle_change_info_seo} />
											</div>

											<div className="mb-3">
												<label className="col-form-label fw-bold fs-6">{language[lang].seo_keywords} <span className="text-muted fs-9">{language[lang].seo_keywords_small}</span></label>
												<input type="text" name="keywords" value={dados.current.info.seo ? dados.current.info.seo.keywords : ''} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].seo_keywords_placeholder} onChange={handle_change_info_seo} />
											</div>

											<div className="mb-3">
												<label className="col-form-label fw-bold fs-6">{language[lang].seo_description}</label>
												<textarea type="text" name="description" value={dados.current.info.seo ? dados.current.info.seo.description : ''} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].seo_description_placeholder} onChange={handle_change_info_seo} />
											</div>
										</div>

									</div>
								</div>
							</div>

						</div>

						
						{
							//formation modules
							is_edit === true ?

								<div className="row" id="modules">
									<div className="col-md-8 mb-5">
										<div className="card">
											<div className="card-header border-0 d-flex justify-content-sm-between">
												<div className="card-title m-0">
													<h3 className="fw-bolder m-0">{language[lang].modules}</h3>
												</div>
												<div className="card-toolbar d-none">
													<ul className="nav nav-tabs nav-line-tabs nav-stretch fs-6 border-0">
														
													</ul>
												</div>
											</div>
										</div>
										<div className="row border-top p-3">									
											<div className="col-12 mb-2">
												<label className="col-form-label fw-bold fs-6">{language[lang].module_name}</label>
												<input type="text" name="module_name" value={module_name} onChange={handle_change_content_module} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].module_name_placeholder} />
											</div>
											<div className="col-12 mb-2">
												<label className="col-form-label fw-bold fs-6">{language[lang].module_objectives}</label>
												<AssecCKEditor
													name="module_objectives"
													value={module_objectives}
													content={module_objectives}
													//content={el_lang.id === '1' ? elem.description : get_value_module_content_lang(index, el_lang.id, 'description')}
													func={(e) => handle_change_content_module_objectives_ckeditor_nolang(e)}
													//func={(e) => handle_change_content_module_ckeditor(e, 0, el_lang.id, el_lang.code, 'description')}
												/>
												<textarea type="text" name="module_objectives" value={module_objectives} onChange={handle_change_content_module} className="form-control mb-3 mb-lg-0 rounded-0 d-none" placeholder={language[lang].module_objectives_placeholder} />
											</div>
											<div className="col-12 mb-2">
												<label className="col-form-label fw-bold fs-6">{language[lang].module_description}</label>
												<AssecCKEditor
													name="module_description"
													value={module_description}
													content={module_description}
													//content={el_lang.id === '1' ? elem.description : get_value_module_content_lang(index, el_lang.id, 'description')}
													func={(e) => handle_change_content_module_ckeditor_nolang(e)}
													//func={(e) => handle_change_content_module_ckeditor(e, 0, el_lang.id, el_lang.code, 'description')}
												/>
												<textarea type="text" name="module_description" value={module_description} onChange={handle_change_content_module} className="form-control mb-3 mb-lg-0 rounded-0 d-none" placeholder={language[lang].module_description_placeholder} />
											</div>
											<div className="col-4">
												<label className="col-form-label fw-bold fs-6">{language[lang].sessions_number}</label>
												<input type="number" name="module_sessions_number" value={module_sessions_number} onChange={handle_change_content_module} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].sessions_placeholder} />
											</div>
											<div className="col-4">
												<label className="col-form-label fw-bold fs-6">{language[lang].module_evaluations_number}</label>
												<input type="number" name="module_evaluations_number" value={module_evaluations_number} onChange={handle_change_content_module} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].module_evaluations_number_placeholder} />
											</div>
											<div className="col-4">
												<label className="col-form-label fw-bold fs-6">{language[lang].duration}</label>
												<input type="number" name="module_duration" value={module_duration} onChange={handle_change_content_module} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].duration_placeholder} />
											</div>
											<div className="col-6">
												<label className="col-form-label fw-bold fs-6">{language[lang].module_evaluation}</label>
												<input type="text" name="module_evaluation" value={module_evaluation} onChange={handle_change_content_module} className="form-control mb-3 mb-lg-0 rounded-0" placeholder={language[lang].module_evaluation_placeholder} />
											</div>
											<div className="col-12 mt-3">
												<button className="btn btn-secondary float-right" type="button" onClick={add_new_module}>{language[lang].module_add}</button>
											</div>
										</div>

										<div className="accordion mb-3 p-3 border-0" id="accordion_modules">
											{
											dados.current.content[0].modules.length > 0 ?

												dados.current.content[0].modules.map((elem, index) => { 
													if(elem.name === '')
														return ''
													else{						
														return (
															<div key={ `${index}` }>
																
																	<div className="accordion-item mt-3">
																		<div className="accordion-header" id={"heading-" + index}>

																			<h2 className="mb-0">
																				<button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target={"#collapse-" + index} aria-expanded="false" aria-controls={"collapse-" + index}>
																					<b>{index + 1}</b>
																					&nbsp;&#45;&nbsp;
																					{elem.name}
																				</button>
																			</h2>

																		</div>

																		<div id={"collapse-" + index} className={"accordion-collapse collapse"} aria-labelledby={"heading-" + index} data-bs-parent="#accordion_modules">
																			<div className="accordion-body">															
			
																				<div className="row border-top p-3" >
																					<div className="col-12 mb-2">
																						<ul className="nav nav-tabs fs-6 border-0 float-right">
																							{
																							content_language.length > 1 ?
																								content_language.map((el_lang, k_lang) => {
																									return (
																										<li key={k_lang} className="nav-item">
																											<a className={"btn btn-sm btn-secondary rounded-0 multi-item" + (k_lang === 0 ? " active" : "")} data-bs-toggle="tab" href={"#kt_tab_pane_module_content_" + index + "_language_" + k_lang}>{el_lang.code}</a>
																										</li>
																									)
																								})
																							:
																								''
																							}
																						</ul>
																					</div>
																				</div>
																				
																				<div className="tab-content" id={"tabModuleContentLang_" + index} >
																					{
																						content_language.length > 1 ?
																							content_language.map((el_lang, k_lang) => {
																								return (
																									<div key={k_lang} className={"tab-pane" + (k_lang === 0 ? " show active" : '')} id={"kt_tab_pane_module_content_" + index +  "_language_" + k_lang} role="tabpanel">
																										<div className="row px-3" >
																											<div className="col-12 mb-2">
																												<label className="col-form-label fw-bold fs-6">{language[lang].module_name}{k_lang > 0 ? '(' + el_lang.code + ')' : ''}</label>
																												<input
																													type="text"
																													name="name"
																													//defaultValue={elem.name}
																													className="form-control mb-3 mb-lg-0 rounded-0"
																													data-order={index}
																													data-langid={el_lang.id}
																													data-lang={el_lang.code}
																													defaultValue={el_lang.id === '1' ? elem.name : get_value_module_content_lang(index, el_lang.id, 'name') }
																													data-index = { index } 
																													onChange={handle_change_edit_content_module_with_lang}
																												/>
																											</div>
																											<div className="col-12 mb-2">
																												<label className="col-form-label fw-bold fs-6">{language[lang].module_objectives}{k_lang > 0 ? '(' + el_lang.code + ')' : ''}</label>
																												<AssecCKEditor
																													name={"text-" + index}
																													content={el_lang.id === '1' ? elem.objectives : get_value_module_content_lang(index, el_lang.id, 'objectives')}
																													func={(e) => handle_change_content_module_ckeditor(e, index, el_lang.id, el_lang.code, 'objectives')}
																												/>
																												<textarea
																													type="text"
																													name="objectives"
																													rows="4"
																													//defaultValue={elem.description}
																													data-order={index}
																													data-langid={el_lang.id}
																													data-lang={el_lang.code}
																													defaultValue={el_lang.id === '1' ? elem.objectives : get_value_module_content_lang(index, el_lang.id, 'objectives') }
																													onChange={handle_change_edit_content_module_with_lang}
																													data-index = { index } 
																													className="form-control mb-3 mb-lg-0 rounded-0 d-none"
																												/>
																											</div>
																											<div className="col-12 mb-2">
																												<label className="col-form-label fw-bold fs-6">{language[lang].module_description}{k_lang > 0 ? '(' + el_lang.code + ')' : ''}</label>
																												<AssecCKEditor
																													name={"text-" + index}
																													content={el_lang.id === '1' ? elem.description : get_value_module_content_lang(index, el_lang.id, 'description')}
																													func={(e) => handle_change_content_module_ckeditor(e, index, el_lang.id, el_lang.code, 'description')}
																												/>
																												<textarea
																													type="text"
																													name="description"
																													rows="4"
																													//defaultValue={elem.description}
																													data-order={index}
																													data-langid={el_lang.id}
																													data-lang={el_lang.code}
																													defaultValue={el_lang.id === '1' ? elem.description : get_value_module_content_lang(index, el_lang.id, 'description') }
																													onChange={handle_change_edit_content_module_with_lang}
																													data-index = { index } 
																													className="form-control mb-3 mb-lg-0 rounded-0 d-none"
																												/>
																											</div>
																											<div className="col-4">
																												<label className="col-form-label fw-bold fs-6">{language[lang].sessions_number}</label>
																												<div className='input-group'>
																													<div className='input-group-text p-0'>
																														<Link
																															title={language[lang].sessions_gest}
																															alt={language[lang].sessions_gest}
																															to={{ 
																																pathname: '/formation_module_regist',
																																state: {
																																	item: {id_formation: dados.current.id, id_module: elem.id},
																																	operation: 'edit',
																																	backup_operation: 'session_view',
																																	formation_id: dados.current.id
																																},
																															}} >
																															<i className="bi bi-gear fs-4 px-2"></i>
																														</Link>
																													</div>
																													<input
																														type="number"
																														name="sessions_number"
																														defaultValue={elem.sessions_number}
																														data-index = { index } 
																														onChange={handle_change_edit_content_module}
																														className="form-control mb-3 mb-lg-0 rounded-0"
																													/>
																												</div>
																											</div>
																											<div className="col-4">
																												<label className="col-form-label fw-bold fs-6">{language[lang].module_evaluations_number}</label>
																												<input
																													type="number"
																													name="evaluations_number"
																													defaultValue={elem.evaluations_number}
																													data-index = { index } 
																													onChange={handle_change_edit_content_module}
																													className="form-control mb-3 mb-lg-0 rounded-0"
																												/>
																											</div>
																											<div className="col-4">
																												<label className="col-form-label fw-bold fs-6">{language[lang].duration}</label>
																												<input
																													type="number"
																													name="duration"
																													defaultValue={elem.duration}
																													data-index = { index } 
																													onChange={handle_change_edit_content_module}
																													className="form-control mb-3 mb-lg-0 rounded-0"
																												/>
																											</div>
																											<div className="col-6">
																												<label className="col-form-label fw-bold fs-6">{language[lang].module_evaluation}{k_lang > 0 ? '(' + el_lang.code + ')' : ''}</label>
																												<input
																													type="text"
																													name="evaluation"
																													//defaultValue={elem.evaluation}
																													data-order={index}
																													data-langid={el_lang.id}
																													data-lang={el_lang.code}
																													defaultValue={el_lang.id === '1' ? elem.evaluation : get_value_module_content_lang(index, el_lang.id, 'evaluation') }
																													onChange={handle_change_edit_content_module_with_lang}
																													data-index = { index }
																													className="form-control mb-3 mb-lg-0 rounded-0"
																												/>
																											</div>
																											<div className="col-12 mt-3">
																												<div className='float-right'>
																													<button className="btn btn-primary me-3" type="button" onClick={save_modules}>
																														{language[lang].save}
																													</button>
																													<button className="btn btn-danger" type="button" onClick = {() => removeInputModule(index) } >
																														{language[lang].remove}
																													</button>
																												</div>
																											</div>
																										</div>
																									</div>
																								)
																							})
																						: 
																							''
																					}
																				</div>
				
																			</div>
																		</div>
																	</div>
																
															</div>
														)
													}
												})
												: ''
											}
										</div>

											{/* {
												dados.current.content[0].modules.length > 0 ?

													dados.current.content[0].modules.map((elem, index) => {
														if(elem.name === '')
															return ''
														else {

															return(
																<div key={ `${index}` } className="row border-top p-3" >
																	<div className="col-12">
																		<label className="col-form-label fw-bold fs-6">{language[lang].module_name}</label>
																		<input
																			type="text"
																			name="name"
																			defaultValue={elem.name}
																			className="form-control mb-3 mb-lg-0 rounded-0"
																			data-index = { index } 
																			onChange={handle_change_edit_content_module}
																		/>
																	</div>
																	<div className="col-12">
																		<label className="col-form-label fw-bold fs-6">{language[lang].module_description}</label>
																		<textarea
																			type="text"
																			name="description"
																			defaultValue={elem.description}
																			onChange={handle_change_edit_content_module}
																			data-index = { index } 
																			className="form-control mb-3 mb-lg-0 rounded-0"
																		/>
																	</div>
																	<div className="col-4">
																		<label className="col-form-label fw-bold fs-6">{language[lang].sessions_number}</label>
																		<input
																			type="number"
																			name="sessions_number"
																			defaultValue={elem.sessions_number}
																			data-index = { index } 
																			onChange={handle_change_edit_content_module}
																			className="form-control mb-3 mb-lg-0 rounded-0"
																		/>
																	</div>
																	<div className="col-4">
																		<label className="col-form-label fw-bold fs-6">{language[lang].module_evaluation}</label>
																		<input
																			type="text"
																			name="evaluation"
																			defaultValue={elem.evaluation}
																			data-index = { index } 
																			onChange={handle_change_edit_content_module}
																			className="form-control mb-3 mb-lg-0 rounded-0"
																		/>
																	</div>
																	<div className="col-4">
																		<label className="col-form-label fw-bold fs-6">{language[lang].duration}</label>
																		<input
																			type="number"
																			name="duration"
																			defaultValue={elem.duration}
																			data-index = { index } 
																			onChange={handle_change_edit_content_module}
																			className="form-control mb-3 mb-lg-0 rounded-0"
																		/>
																	</div>
																	<div className="col-12 mt-3">
																		<button className="btn btn-danger float-right" onClick = {() => removeInputModule(index) } >
																			{language[lang].remove}
																		</button>
																	</div>
																</div>
															)
														}
													})
												: ''											
											} */}

									</div>
								</div>
							: ''
						}
						{
							//formation trainers
							is_edit === true /*&& add_trainers_permission*/ ?

								<div className="row d-none" id="trainers">
									<div className="col-md-8 mb-5">
										<div className="card">
											<div className="card-header border-0 d-flex justify-content-sm-between">
												<div className="card-title m-0">
													<h3 className="fw-bolder m-0">{language[lang].trainer}</h3>
												</div>
											</div>
										</div>
										<div className="row border-top p-3">
											<div className="col-12 col-sm-6">
												<Select
													options={trainers}
													name="trainer"
													placeholder={language[lang].select_trainer_placeholder}
													value={trainer_selected.label === '' ? null : trainer_selected}
													onChange={handle_selected_trainers}
													menuPlacement='top'
													//styles={custom_select_styles}
												/>
												
												
											</div>
											<div className="col-12 col-sm-6">
												<button className="btn btn-secondary" type="button" onClick={add_trainer} alt={language[lang].add_trainer} title={language[lang].add_trainer}>
													<img className="assec-mr-15" alt={language[lang].add_trainer} title={language[lang].add_trainer} src={'./img/plus.svg'} />
													{language[lang].add_trainer}
												</button>
											</div>
											{ 
												dados.current.info.trainers !== undefined && dados.current.info.trainers.length > 0 ? (
													<div className="col-12 col-sm-8">
														<label className='col-form-label fw-bold fs-6'>{language[lang].trainers}</label>
														{
															dados.current.info.trainers.map( ( elem , index ) => {
																
																if(elem.name === '')
																	return ''
																else
																	return(
																		
																		<div  key = { `${index}` } className="d-flex mb-3">
																			<input
																				type="text" 
																				className = "form-control"  
																				name ="nome"  
																				value = { elem.name } 
																				data-index = { index }
																				readOnly
																			/>
																			
																			<button  className = "ms-3 assec-btn-remove" onClick = {() => removeInputTrainer(index) }>
																				<img src ="./img/adicionar.svg" alt={language[lang].remove_trainer} title={language[lang].remove_trainer} />
																			</button>
																			{/* <button className={(elem.trainers.notified === true ? 'button-green' : 'button-yellow') + " ml-4"} type="button" onClick={ () => save_reviewer_and_send_notification(elem.trainers.id, elem.trainers.name)}>
																				{(elem.trainers.notified === true ? language[lang].notified : language[lang].notify)}
																			</button> */}
																		</div>
																		
																	)
															})											
														}
														
													</div>
												) : null 
											}
										</div>

									</div>
								</div>
							: ''
						}
					</div>
				</div>

				<div className={'dash-cards footer'}>
					<nav className="navbar bottom-navbar navbar-light">
						<div className="navbar-footer">
							<ul className="navbar-nav float-left"></ul>
							<ul className="navbar-nav float-right">
								{
									props.location.state !== undefined && props.location.state.return_button_endpoint === 'list2' ? (
										<li className='nav-item'>
											<Link className="nav-link btn-cancel" to={{ pathname: endpoints.list2 }}  >
												<img alt={language[lang].back} src={'./img/seta_2.svg'} />
												<span>{language[lang].back}</span>
											</Link>

										</li>
									) : 

										props.location.state !== undefined && props.location.state.go_back_operation === 'main_view' ? (
											<li className="nav-item">
												<Link className="nav-link btn-cancel" to={{ pathname: Main.view.endpoint}}  >
													<img alt={language[lang].back} src={'./img/seta_2.svg'} />
													<span>{language[lang].back}</span>
												</Link>
											</li> 
										) :
											<li className="nav-item">
												<Link className="nav-link btn-cancel" to={{ pathname: endpoints.list }}  >
													{/*<img alt='' src={'./img/cancelar.svg'} />
													<span>{language[lang].cancel}</span>*/}
													<img alt={language[lang].back} src={'./img/seta_2.svg'} />
													<span>{language[lang].back}</span>
												</Link>
											</li> 
								}
								<li className={"nav-item " + show_delete_button}>
									<button type="button" onClick={() => apagar(dados.current.id)} className="nav-link btn-delete">
										<img alt='' src={'./img/eliminar_b.svg'} />
										<span>{language[lang].delete}</span>
									</button>
								</li>
								<li className="nav-item">
									<button type="submit" form="form" className="nav-link">
										<img alt='' src={'./img/save.svg'} />
										<span>{language[lang].save}</span>
									</button>
								</li>
							</ul>
						</div>
					</nav>
				</div>
			</form>
		</main>

}
